import { CacheService } from 'web_core_library';
import { ITrainingWorkoutState, SessionCacheError } from './types';

let _userId = 0;

async function init(userId: number) {
  _userId = userId;
  await CacheService.init();
}

async function getWorkoutStates() {
  if (!_userId) {
    throw new SessionCacheError('SessionCache requires userId to be set!');
  }
  try {
    return await CacheService.load(`${_userId}-workoutstates`);
  } catch (error) {
    throw new SessionCacheError('Workouts SessionCache loading failed');
  }
}

async function setWorkoutStates(workoutstates: ITrainingWorkoutState[]) {
  if (!_userId) {
    throw new SessionCacheError('SessionCache requires userId to be set!');
  }
  try {
    return await CacheService.save(`${_userId}-workoutstates`, workoutstates);
  } catch (error) {
    throw new SessionCacheError('Workouts SessionCache saving failed');
  }
}

async function clearWorkoutStates() {
  if (!_userId) {
    throw new SessionCacheError('SessionCache requires userId to be set!');
  }
  try {
    return await CacheService.delete(`${_userId}-workoutstates`);
  } catch (error) {
    throw new SessionCacheError('Workouts SessionCache clearing failed');
  }
}

const SessionCacheService = {
  init,
  getWorkoutStates,
  setWorkoutStates,
  clearWorkoutStates,
};
export default SessionCacheService;
